export default function Pricing() {
  const plans = [
    {
      name: 'Website Build',
      price: '$1,000',
      period: 'one-time',
      description:
        'Professional website design and setup. $500 up-front after preview, $500 at go live.',
      features: [
        'Custom website design',
        'Mobile-responsive layout',
        'Professional content layout',
        'Initial SEO optimization',
        'Contact form integration',
        'Social media links',
      ],
      cta: 'Get Started',
      highlighted: false,
    },
    {
      name: 'Managed Website Plan',
      price: '$99',
      period: 'per month',
      description: 'Hosting plus website updates and maintenance after initial build',
      features: [
        'Everything in Basic Hosting',
        'Unlimited content updates',
        'Monthly performance reports',
        'Priority support',
        'SEO monitoring',
        'Regular backups',
      ],
      cta: 'Choose Plan',
      highlighted: true,
      badge: 'Most Popular',
    },
    {
      name: 'Basic Hosting Plan',
      price: '$50',
      period: 'per month',
      description: 'Website hosting, security, and backups after initial build',
      features: [
        'Fast & reliable hosting',
        'SSL security certificate',
        'Daily automated backups',
        'Email support',
        '99.9% uptime guarantee',
        'Basic maintenance',
      ],
      cta: 'Get Started',
      highlighted: false,
    },
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-20 lg:py-32 bg-gradient-to-b from-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-20">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">Pricing</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">Simple, Transparent Pricing</h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-2xl mx-auto">
            No hidden fees. Choose the plan that works best for your business.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-start">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-gray-950 border rounded-3xl p-8 sm:p-12 transition-all duration-300 ${
                plan.highlighted
                  ? 'border-white/20 shadow-2xl shadow-white/10 md:scale-105'
                  : 'border-white/10 hover:border-white/20'
              }`}
            >
              {plan.badge && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-white text-black text-xs font-bold px-4 py-2 rounded-full whitespace-nowrap">
                    {plan.badge}
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-sm uppercase text-gray-400 tracking-wider mb-4">{plan.name}</h3>
                <div className="mb-4">
                  <span className="text-4xl sm:text-5xl font-bold text-white">{plan.price}</span>
                  <span className="text-gray-400 ml-2">/ {plan.period}</span>
                </div>
                <p className="text-sm text-gray-400">{plan.description}</p>
              </div>

              <div className="border-t border-white/10 my-8"></div>

              <ul className="space-y-4 mb-10">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full border border-white/30 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs text-white"></i>
                    </div>
                    <span className="text-sm text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={scrollToContact}
                className={`w-full py-4 rounded-xl font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  plan.highlighted
                    ? 'bg-white text-black hover:bg-gray-200'
                    : 'bg-black border border-white/20 text-white hover:bg-white hover:text-black'
                }`}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}